var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.565 18.377h-7.13c-2.986 0-5.435 2.45-5.435 5.435V33h18v-9.188c0-3-2.45-5.435-5.435-5.435Zm3.623 12.811h-1.782V25.13h-1.812v6.058h-7.188V25.13h-1.812v6.058h-1.782v-7.376c0-2 1.623-3.624 3.623-3.624h7.13c2 0 3.623 1.624 3.623 3.624v7.376ZM20 17.246a5.629 5.629 0 0 0 5.623-5.623A5.629 5.629 0 0 0 20 6a5.629 5.629 0 0 0-5.623 5.623A5.629 5.629 0 0 0 20 17.246Zm0-9.434a3.816 3.816 0 0 1 3.812 3.811A3.816 3.816 0 0 1 20 15.435a3.816 3.816 0 0 1-3.812-3.812A3.816 3.816 0 0 1 20 7.812Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.9395e5603e9e152b0212e717bcfbf90a.svg";
export { ForwardRef as ReactComponent };